module.exports = __webpack_public_path__ + "static/img/begin.868434c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/begin.png
// module id = +SHa
// module chunks = 1